export type Staleness = 'fresh' | 'stale' | 'expired';

const DAY = 86_400_000;

export function parseAsOf(asOf: string | undefined): Date | null {
  if (!asOf) return null;
  const iso = asOf.match(/\d{4}-\d{2}-\d{2}/);
  if (iso) {
    const d = new Date(`${iso[0]}T00:00:00Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const long = asOf.match(/[A-Z][a-z]{2,8}\.? \d{1,2}, \d{4}/);
  if (long) {
    const d = new Date(long[0]);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

export function ageDays(date: Date, now = new Date()): number {
  return Math.floor((now.getTime() - date.getTime()) / DAY);
}

/** Snapshots older than 90 days need a refresh; older than 180 days are expired. */
export function stalenessOf(asOf: string | undefined): { level: Staleness; days: number | null } {
  const d = parseAsOf(asOf);
  if (!d) return { level: 'fresh', days: null };
  const days = ageDays(d);
  if (days > 180) return { level: 'expired', days };
  if (days > 90) return { level: 'stale', days };
  return { level: 'fresh', days };
}
